<app-dialog-header headerKey="passwd.reset"></app-dialog-header>
<mat-dialog-content>
  {{ 'passwd.resetTT' | loc }}:
  <app-text-input labelKey="Email" [formControl]="email" [outsideLabel]="false"> </app-text-input>
</mat-dialog-content>

<mat-dialog-actions align="center">
  <button mat-button [disabled]="sent" (click)="send()">{{ 'button.send' | loc }}</button>
</mat-dialog-actions>
